import { createRoute, useParams } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const TransparencyView = lazy(async () => {
  const m = await import("@/features/supervision/components/transparency-view");
  return { default: m.TransparencyView };
});

function TransparencyPage() {
  const params = useParams({ from: "/_app/supervised/$profileId/transparency" });
  return (
    <Suspense fallback={null}>
      <TransparencyView profileId={params().profileId} />
    </Suspense>
  );
}

export const supervisedTransparencyRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/supervised/$profileId/transparency",
  component: TransparencyPage,
});
